// Some browser wallet extensions (notably TokenPocket) throw internal errors
// from their injected `inpage.js` — e.g. "Cannot read properties of undefined
// (reading '_bn')" during their own accountsChanged/otherChainAccountChange
// handling. Those errors originate entirely inside the extension, not our code,
// but in dev they trip CRA's full-screen error overlay and block the page.
// This guard swallows errors that originate from a wallet extension so our UI
// stays usable (the wallet's own event still fails inside the extension, but it
// never takes down our app). No effect on our own errors.
const isWalletExtError = (source, message) => {
  const s = String(source || "");
  const m = String(message || "");
  if (s.includes("chrome-extension://") || s.includes("moz-extension://")) return true;
  // Fallback: match the known TokenPocket signature even if the source is stripped.
  if (/reading '?_bn'?/.test(m)) return true;
  if (/otherChainAccountChange|accountsChanged/.test(s)) return true;
  return false;
};

// CRA / webpack-dev-server shows a full-screen "Uncaught runtime errors" overlay
// in dev (preview only). Our capture-phase listeners can't always beat its own
// listener, so when we spot a wallet-extension error we also yank the overlay
// node out of the DOM for a short window. No-op in production (no overlay node).
const nukeDevOverlay = () => {
  if (typeof document === "undefined") return;
  const kill = () => {
    document
      .querySelectorAll('[id^="webpack-dev-server-client-overlay"], iframe[src*="/__webpack_dev_server__"]')
      .forEach((n) => { try { n.remove(); } catch { /* noop */ } });
  };
  kill();
  let n = 0;
  const iv = setInterval(() => { kill(); if (++n > 12) clearInterval(iv); }, 150);
};

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const src = e?.filename || e?.error?.stack || "";
      if (isWalletExtError(src, e?.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        nukeDevOverlay();
      }
    },
    true,
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      const reason = e?.reason;
      const src = reason?.stack || "";
      if (isWalletExtError(src, reason?.message || reason)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        nukeDevOverlay();
      }
    },
    true,
  );
}
